import { initializeIcons, registerIcons } from "@fluentui/react";
import { DEFAULT_COMPONENT_ICONS, DEFAULT_COMPOSITE_ICONS } from "@azure/communication-react";

export function registerFluentUiIcons() {
    initializeIcons();
    const icons = {
        ...DEFAULT_COMPONENT_ICONS,
        ...DEFAULT_COMPOSITE_ICONS,
    };
    registerIcons({ icons });
}

